import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SettingsTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "General",
      path: "/admin/settings/add"
    },
    {
      label: "Domain",
      path: "/admin/domain/add"
    },
    {
      label: "Security",
      path: "/admin/security-settings"
    },
    {
      label: "Billing",
      path: "/admin/billing"
    },
    {
      label: "Integration",
      path: "/admin/integration"
    },
    {
      label: "Terminology",
      path: "/admin/terminology"
    },
    {
      label: "Numbering",
      path: "/admin/numbering"
    },
    {
      label: "Notifications",
      path: "/admin/notification-setting"
    },
    {
      label: "Approval Workflows",
      path: "/admin/approvalmatrix"
    },
    
   
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default SettingsTabs;